import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { IoMdCheckmarkCircle } from "react-icons/io";
import logo from '../../../assets/atsPious/logo.png'

import heroImg1 from '../../../assets/atsPious/mainFeed-1.jpg'
import heroImg2 from '../../../assets/atsPious/mainFeed-2.png'
import heroImg3 from '../../../assets/atsPious/mainFeed-3.webp'
import heroImg4 from '../../../assets/atsPious/mainFeed-4.jpg'

import ameneties1 from '../../../assets/atsPious/ameneties-1.jpg'
import ameneties2 from '../../../assets/atsPious/ameneties-2.png'
import ameneties3 from '../../../assets/atsPious/ameneties-3.webp'
import ameneties4 from '../../../assets/atsPious/ameneties-4.png'
import ameneties5 from '../../../assets/atsPious/ameneties-5.png'

import interior1 from '../../../assets/atsPious/interior-1.jpg'
import interior2 from '../../../assets/atsPious/interior-2.jpg'
import interior3 from '../../../assets/atsPious/interior-3.png'
import interior4 from '../../../assets/atsPious/interior-4.png'
import interior5 from '../../../assets/atsPious/interior-5.png'


import { ImageModal } from '../../common/ImageModal';
import { ConnectForm } from '../../common/ConnectForm';
import ImageSwiper from '../../common/ImageSwiper';


const AtsPious = () => {
    const location = useLocation();
    const [openImgModal, setOpenImgModal] = useState(false);

    const [selectedImgIndex, setSelectedImgIndex] = useState(null);
    const [activeImageType, setActiveImageType] = useState(null);

    const images = [heroImg1, heroImg2, heroImg3, heroImg4];
    const interiors = [interior1, interior2, interior3, interior4, interior5]
    const ameneties = [ameneties1, ameneties2, ameneties3, ameneties4, ameneties5]


    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);



    const handleOpenModal = (index, type) => {
        setSelectedImgIndex(index);
        setActiveImageType(type);
        setOpenImgModal(true);
    };

    return (
        <div className="w-full min-h-screen bg-gray-100">
            <ImageSwiper images={images} />
            <div className="w-full p-2 flex justify-center items-center overflow-hidden transition-all duration-500">
                <div className="w-[90%] sm:w-[80%] md:w-[70%] lg:w-[60%] xl:w-[50%] max-h-[300px]">
                    <img src={logo} alt="logo" className="w-full h-full object-contain rounded-lg" />
                </div>
            </div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div className="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify font-semibold">
                                ATS Homekraft Pious Orchards is a luxurious residential project located in <strong>Sector 150, Noida </strong>
                                designed to offer a serene and modern lifestyle. Here are the key details:
                            </p>
                            <h2 className="text-2xl md:text-3xl font-bold my-2">Project Highlights:</h2>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Configuration:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The project offers spacious <strong>3 BHK and  5 BHK apartment</strong> with sizes
                                        ranging from <strong>2350 sq. ft. to 3200 sq. ft.</strong>
                                    </p>
                                </div>
                            </section>

                            <section className="p-2 md:p-3 bg-gray-100 text-gray-900">
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Design:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        : Each apartment is thoughtfully designed to face both the  <strong>Yamuna River </strong> and an
                                        <strong> orchard-themed central park </strong>, ensuring breathtaking views and a connection with nature.                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Green Living:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Spread over <strong>9.31 acres </strong>, the project dedicates <strong> 80% of its area to open
                                            spaces </strong>, including lush greenery, gardens, and water bodies.
                                    </p>
                                </div>
                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Amenities:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        Residents can enjoy a wide range of amenities such as
                                    </p>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-medium">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Swimming pool with a pool deck
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Clubhouse
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Yoga and herb gardens
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Amphitheater
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Reflexology path
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Barbecue garden and outdoor grill
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Forest trails and cabanas
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1"><IoMdCheckmarkCircle size={20} /></span>
                                            Cocoon reading spaces for book lovers
                                        </li>
                                    </ul>
                                </div>

                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Location Advantages:</h3>
                                    <ul className="space-y-1 text-left max-w-2xl my-2 font-medium">
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1">
                                                <IoMdCheckmarkCircle size={20} />
                                            </span>
                                            Proximity to Noida-Greater Noida Expressway and Yamuna Expressway.
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1">
                                                <IoMdCheckmarkCircle size={20} />
                                            </span>
                                            Close to landmarks like Shaheed Bhagat Singh Park, Sanfort World School, and MSX Mall.
                                        </li>
                                        <li className="flex items-start">
                                            <span className="text-green-600 mr-2 mt-1">
                                                <IoMdCheckmarkCircle size={20} />
                                            </span>
                                            Easy access to Noida Sector 143 Metro Station, Indira Gandhi International Airport, and other key destinations.
                                        </li>
                                    </ul>
                                </div>

                                <div className="max-w-4xl mx-auto">
                                    <h3 className="font-semibold text-xl md:text-2xl mb-2">Completion Timeline:</h3>
                                    <p className="text-md text-gray-700 my-1 text-justify">
                                        The project is currently under construction and is expected to be
                                        completed by <strong>December 2026</strong>
                                    </p>
                                </div>

                                <p className="text-md text-gray-700 my-4 text-justify font-semibold">
                                    This development combines luxury, comfort, and eco-friendly living, making it an ideal choice for
                                    families and investors
                                </p>
                            </section>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            <h2 className="text-2xl font-semibold text-gray-800 m-4">
                Projects Highlights
            </h2>
            {openImgModal && activeImageType === "ameneties" && (
                <ImageModal
                    images={ameneties}
                    openImg={openImgModal}
                    selectedImgIndex={selectedImgIndex}
                    onClose={() => setOpenImgModal(false)}
                />
            )}

            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {ameneties.map((data, index) => (
                    <div
                        key={index}
                        onClick={() => handleOpenModal(index, "ameneties")}
                        className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                    >
                        <img
                            src={data}
                            alt="ATS"
                            className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                        />
                    </div>
                ))}
            </div>

            <div className="max-w-7xl mx-auto p-4">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                    Luxury  Insights
                </h2>

                {openImgModal && activeImageType === "interiors" && (
                    <ImageModal
                        images={interiors}
                        openImg={openImgModal}
                        selectedImgIndex={selectedImgIndex}
                        onClose={() => setOpenImgModal(false)}
                    />
                )}

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                    {interiors.map((data, index) => (
                        <div
                            key={index}
                            onClick={() => handleOpenModal(index, "interiors")}
                            className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                        >
                            <img
                                src={data}
                                alt="ATS"
                                className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                            />
                        </div>
                    ))}
                </div>

            </div>
        </div>
    )
}
export default AtsPious